import * as React from 'react'
import { withRouter } from 'react-router'
import UserStore from '../../../Stores/UserStore'
import { history } from '../../../Routing'
import HttpActionsService from '../../../Services/HttpActionsService'
import { inject, observer } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import PaymentsStore from '../../../Stores/PaymentsStore'
import {
    getPaymentStatusText,
    getPaymentSourceText,
    getPaymentTypeText,
    getPaymentDirectionText
} from '../../../Model/Payment'
import { Button } from 'react-bootstrap'
import DateTimeHelper from '../../../Helpers/DateTimeHelper'
import { Link } from 'react-router-dom'
import PaymentCancelView from '../../PartialViews/Payment/PaymentCancelView'

export interface IPaymentPageProps {
    httpActionsService?: HttpActionsService
    paymentsStore?: PaymentsStore
    localizationStore?: LocalizationStore
    userStore: UserStore
}

@inject('httpActionsService')
@inject('paymentsStore')
@inject('localizationStore')
@inject('userStore')
@observer
export class PaymentPage extends React.Component<IPaymentPageProps> {
    constructor(props: any) {
        super(props)

        if (!UserStore.getInstance().checkSession) {
            history.push('/login')
        }

        if (this.props['match']!['params']['id']) {
            this.props.httpActionsService!.getPayment(this.props['match']!['params']['id'])
        } else {
            this.props.httpActionsService!.clearPayment()
        }
    }

    render() {
        const { paymentsStore, localizationStore } = this.props
        let p = paymentsStore!.getItem

        if (!p) {
            return (
                <div>
                    <div className="row">
                        <div className="col-12">
                            {localizationStore!.t('no data')}
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-12 paymentBtns">
                            <Button
                                onClick={() => { history.push('/payments') }}
                            >
                                {localizationStore!.t!('backToList')}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        {localizationStore!.t('description')} : {p.description}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('id')}: {p.id}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('source')}: {p.questionnaireSource}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('externalKey')}: {p.questionnaireExternalKey}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('creditNumber')}: {p.creditNumber}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('questionnaireCreateDate')}: {DateTimeHelper.formatDateForList(p.questionnaireCreateDate)}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('amountSum')}: {p.amount}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('paymentDateTime')}: {DateTimeHelper.formatDateForList(p.paymentDateTime)}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('createDate')}: {DateTimeHelper.formatDateForList(p.createDate)}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('updateDate')}: {DateTimeHelper.formatDateForList(p.updateDate)}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('paymentStatus')}: {getPaymentStatusText(p.paymentStatus)}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('paymentDirection')}: {getPaymentDirectionText(p.paymentDirection)}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('paymentSource')}: {getPaymentSourceText(p.paymentSource)}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('paymentType')}: {getPaymentTypeText(p.paymentType)}
                    </div>
                    <div className="col-12 col-md-4">
                        {localizationStore!.t('inProgressByUserId')}:
                        <Link
                            className="userDetailLink"
                            to={'/user/' + p.createByUserId}
                            id={p.createByUserId}
                        >
                            {p.createByUserId}
                        </Link>
                    </div>
                </div>

                <PaymentCancelView />

            </div>
        )
    }
}

export default withRouter(PaymentPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Payment/PaymentPage.tsx